import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
// import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { toast } from "react-toastify";
import CustomModal from "../../components/CustomModal";
import Select from "react-select";
import Elements from "../../components/elements/Elements";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";

function OrganizationForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      createdBy: localStorage.getItem("userId"),
      name: "",
      legalName: "",
      registrationNumber: "",
      countryId: "",
      stateId: "",
      cityId: "",
      postalCode: "",
      address: "",
      phoneNumber: "",
      emailAddress: "",
      websiteUrl: "",
      foundedDate: "",
      numberOfEmployees: "",
      primaryContactName: "",
      primaryContactTitle: "",
      primaryContactEmail: "",
      primaryContactPhone: "",
      businessDescription: "",
      companyLogo: "",
      base64String: "",
      logoPath: "",
      linkedInProfile: "",
      facebookProfile: "",
      twitterHandle: "",
      instagramProfile: "",
      accountLength: "",
      elements: [
        {
          name: "",
          description: "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: "",
            description: "",
            effectiveDate: null,
            endDate: null,
            createdBy: localStorage.getItem("userId"),
            fileName: "",
            filePath: "",
            base64String: "",
          },
        },
      ],
    },
  });

  const [logoFileName, setLogoFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);

  const [fileCounts, setFileCounts] = useState({});
  const [fileUrls, setFileUrls] = useState({});
  const [activityCategoryData, setActivityCategoryData] = useState([]);
  const [activityVenueData, setActivityVenueData] = useState([]);

  const [isModalVisible, setModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const showModalWithContent = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setModalVisible(true);
  };

  const hideModal = () => setModalVisible(false);

  const [elementsData, setElementsData] = useState([]);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "elements",
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isOrgDataFetched, setIsOrgDataFetched] = useState(false);

  const selectedCountry = watch("countryId");
  const selectedState = watch("stateId");
  const selectedCity = watch("cityId");
  const [
    isCustomDropdownValuesModalVisible,
    setIsCustomDropdownValuesModalVisible,
  ] = useState(false);
  const [customDropdownName, setCustomDropdownName] = useState("");
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get("Dropdown/GetCountries", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCountries(response);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, [token]);
  const fetchCommonSettings = async (moduleName, setData) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${moduleName}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setData(response?.commonSettingDetail);
    } catch (error) {
      console.error(`Error fetching ${moduleName}:`, error);
    }
  };

  useEffect(() => {
    if (selectedCountry && selectedCountry.value) {
      const fetchStates = async () => {
        try {
          const response = await get(
            `Dropdown/GetStates?countryId=${selectedCountry.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setStates(response);

          setCities([]);
          // setValue("stateId", null);
          // setValue("cityId", null);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry, setValue, token]);

  useEffect(() => {
    if (selectedState && selectedState.value) {
      const fetchCities = async () => {
        try {
          const response = await get(
            `Dropdown/GetCities?stateId=${selectedState.value}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setCities(response);

          // setValue("cityId", null);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };

      fetchCities();
    }
  }, [selectedState, setValue, token]);

  useEffect(() => {
    const fetchElements = async () => {
      try {
        const elementsResponse = await get("Dropdown/GetElements", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setElementsData(elementsResponse);
      } catch (error) {
        console.error("Error fetching elements:", error);
      }
    };

    fetchElements();
  }, []);

  // useEffect(() => {
  //   const fetchOrganizationData = async () => {
  //     try {
  //       if (!organizationId || organizationId === "null") {
  //         return;
  //       }

  //       const singleOrgData = await get(
  //         `Organization/GetOrgnazationById?organizationId=${organizationId}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //           },
  //         }
  //       );

  //       if (!singleOrgData) {
  //         return;
  //       }

  //       // Fetch states based on the organization's countryId
  //       const countryId = singleOrgData?.countryId;
  //       let selectedCountry = null;
  //       let selectedState = null;
  //       let selectedCity = null;

  //       if (countryId) {
  //         selectedCountry = countries.find(
  //           (country) => country.id === countryId
  //         );
  //         const statesResponse = await get(
  //           `Dropdown/GetStates?countryId=${countryId}`,
  //           {
  //             headers: {
  //               Authorization: `Bearer ${token}`,
  //             },
  //           }
  //         );
  //         setStates(statesResponse);

  //         // Fetch cities based on the organization's stateId
  //         const stateId = singleOrgData?.stateId;
  //         if (stateId) {
  //           selectedState = statesResponse.find(
  //             (state) => state.id === stateId
  //           );
  //           const citiesResponse = await get(
  //             `Dropdown/GetCities?stateId=${stateId}`,
  //             {
  //               headers: {
  //                 Authorization: `Bearer ${token}`,
  //               },
  //             }
  //           );
  //           setCities(citiesResponse);
  //           selectedCity = citiesResponse.find(
  //             (city) => city.id === singleOrgData?.cityId
  //           );
  //         }
  //       }

  //       const mappedElements =
  //         singleOrgData?.elementDetailsDto.length > 0
  //           ? singleOrgData.elementDetailsDto.map((element, index) => {
  //               const matchingElement = elementsData.find(
  //                 (item) => item.id === element.elementId
  //               );

  //               const fileUrl =
  //                 process.env.REACT_APP_LIVE_DOMAIN_URL +
  //                 "/ExternalImages/" +
  //                 element.filePath;

  //               const fileCount = element.fileName ? 1 : 0;

  //               setFileCounts((prevCounts) => ({
  //                 ...prevCounts,
  //                 [index]: fileCount,
  //               }));

  //               setFileUrls((prevUrls) => ({
  //                 ...prevUrls,
  //                 [index]: fileUrl,
  //               }));

  //               return {
  //                 id: element.id || 0,
  //                 createdBy:
  //                   element.createdBy || localStorage.getItem("userId"),
  //                 updatedBy: localStorage.getItem("userId"),
  //                 name: matchingElement
  //                   ? { value: matchingElement.id, label: matchingElement.name }
  //                   : null,
  //                 description: element.description || "",
  //                 elementDetail: {
  //                   id: element.id || 0,
  //                   createdBy:
  //                     element.createdBy || localStorage.getItem("userId"),
  //                   updatedBy: localStorage.getItem("userId"),
  //                   formId: element.formId || 0,
  //                   elementId: element.elementId || 0,
  //                   value: element.value || "",
  //                   description: element.description || "",
  //                   effectiveDate: element.effectiveDate?.split("T")[0] || null,
  //                   endDate: element.endDate?.split("T")[0] || null,
  //                   code: element.code || "",
  //                   fileName: element.fileName || "",
  //                   filePath: element.filePath || "",
  //                   base64String: element.base64String || "",
  //                 },
  //                 code: element.code || "",
  //               };
  //             })
  //           : [
  //               {
  //                 id: 0,
  //                 createdBy: localStorage.getItem("userId") || "",
  //                 updatedBy: localStorage.getItem("userId") || "",
  //                 name: null,
  //                 description: "",
  //                 elementDetail: {
  //                   id: 0,
  //                   createdBy: localStorage.getItem("userId") || "",
  //                   updatedBy: localStorage.getItem("userId") || "",
  //                   formId: 0,
  //                   elementId: 0,
  //                   value: "",
  //                   description: "",
  //                   effectiveDate: null,
  //                   endDate: null,
  //                   code: "",
  //                   fileName: "",
  //                   filePath: "",
  //                   base64String: "",
  //                 },
  //                 code: "",
  //               },
  //             ];

  //       const { elementDetailsDto, ...filteredSingleOrgData } = singleOrgData;

  //       if (filteredSingleOrgData.companyLogo !== "") {
  //         const imageUrl =
  //           process.env.REACT_APP_LIVE_DOMAIN_URL +
  //           "ExternalImages" +
  //           filteredSingleOrgData.logoPath;

  //         setPreviewUrl(imageUrl);
  //         setLogoFileName(filteredSingleOrgData.companyLogo);
  //       }

  //       const selectedNoOfEmployeeOption = numberOfEmployeesData.find(
  //         (employee) => employee.id === singleOrgData.numberOfEmployees
  //       );

  //       reset({
  //         ...filteredSingleOrgData,
  //         foundedDate: filteredSingleOrgData.foundedDate?.split("T")[0],
  //         base64String: "",
  //         elements: mappedElements,
  //         id: localStorage.getItem("organizationId"),
  //         updatedBy: localStorage.getItem("userId"),
  //         countryId: { id: selectedCountry.id, label: selectedCountry.name },
  //         stateId: { id: selectedState.id, label: selectedState.name },
  //         cityId: { id: selectedCity.id, label: selectedCity.name },
  //         numberOfEmployees: {
  //           value: selectedNoOfEmployeeOption?.id || "",
  //           label: selectedNoOfEmployeeOption?.value || "",
  //         },
  //       });

  //       setIsOrgDataFetched(true);
  //     } catch (error) {
  //       console.error("Error fetching organization data:", error);
  //     }
  //   };

  //   if (countries.length > 0 && !isOrgDataFetched) {
  //     fetchOrganizationData();
  //   }
  // }, [countries, reset, isOrgDataFetched, token, organizationId]);

  useEffect(() => {
    const fetchOrganizationData = async () => {
      try {
        if (!organizationId || organizationId === "null") return;

        const singleOrgData = await get(
          `Organization/GetOrgnazationById?organizationId=${organizationId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!singleOrgData) return;

        const countryId = singleOrgData?.countryId;
        let selectedCountry = null;
        let selectedState = null;
        let selectedCity = null;

        if (countryId) {
          selectedCountry = countries.find(
            (country) => country.id === countryId
          );
          const statesResponse = await get(
            `Dropdown/GetStates?countryId=${countryId}`,
            { headers: { Authorization: `Bearer ${token}` } }
          );
          setStates(statesResponse);

          const stateId = singleOrgData?.stateId;
          if (stateId) {
            selectedState = statesResponse.find(
              (state) => state.id === stateId
            );
            const citiesResponse = await get(
              `Dropdown/GetCities?stateId=${stateId}`,
              { headers: { Authorization: `Bearer ${token}` } }
            );
            setCities(citiesResponse);
            selectedCity = citiesResponse.find(
              (city) => city.id === singleOrgData?.cityId
            );
          }
        }

        const mappedElements =
          singleOrgData?.elementDetailsDto.length > 0
            ? singleOrgData.elementDetailsDto.map((element, index) => {
                const matchingElement = elementsData.find(
                  (item) => item.id === element.elementId
                );

                const fileUrl = element.filePath
                  ? `${process.env.REACT_APP_LIVE_DOMAIN_URL}/ExternalImages/${element.filePath}`
                  : "";

                setFileCounts((prevCounts) => ({
                  ...prevCounts,
                  [index]: element.fileName ? 1 : 0,
                }));

                setFileUrls((prevUrls) => ({
                  ...prevUrls,
                  [index]: fileUrl,
                }));

                return {
                  id: element.id || 0,
                  createdBy:
                    element.createdBy || localStorage.getItem("userId"),
                  updatedBy: localStorage.getItem("userId"),
                  name: matchingElement
                    ? { value: matchingElement.id, label: matchingElement.name }
                    : {
                        value: element.elementId || 0,
                        label: element.value || "",
                      },
                  description: element.description || "",
                  elementDetail: {
                    id: element.id || 0,
                    createdBy:
                      element.createdBy || localStorage.getItem("userId"),
                    updatedBy: localStorage.getItem("userId"),
                    formId: element.formId || 0,
                    elementId: element.elementId || 0,
                    value: element.value || "",
                    description: element.description || "",
                    effectiveDate: element.effectiveDate?.split("T")[0] || null,
                    endDate: element.endDate?.split("T")[0] || null,
                    code: element.code || "",
                    fileName: element.fileName || "",
                    filePath: element.filePath || "",
                    base64String: element.base64String || "",
                  },
                  code: element.code || "",
                };
              })
            : [
                {
                  id: 0,
                  createdBy: localStorage.getItem("userId"),
                  updatedBy: localStorage.getItem("userId"),
                  name: null,
                  description: "",
                  elementDetail: {
                    id: 0,
                    createdBy: localStorage.getItem("userId"),
                    updatedBy: localStorage.getItem("userId"),
                    formId: 0,
                    elementId: 0,
                    value: "",
                    description: "",
                    effectiveDate: null,
                    endDate: null,
                    code: "",
                    fileName: "",
                    filePath: "",
                    base64String: "",
                  },
                  code: "",
                },
              ];

        const { elementDetailsDto, ...filteredSingleOrgData } = singleOrgData;

        if (filteredSingleOrgData.companyLogo) {
          const imageUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}/ExternalImages${filteredSingleOrgData.logoPath}`;
          setPreviewUrl(imageUrl);
          setLogoFileName(filteredSingleOrgData.companyLogo);
        }

        const selectedNoOfEmployeeOption = numberOfEmployeesData.find(
          (employee) => employee.id === singleOrgData.numberOfEmployees
        );

        reset({
          ...filteredSingleOrgData,
          foundedDate: filteredSingleOrgData.foundedDate?.split("T")[0],
          base64String: "",
          elements: mappedElements,
          id: localStorage.getItem("organizationId"),
          updatedBy: localStorage.getItem("userId"),
          countryId: selectedCountry
            ? { value: selectedCountry.id, label: selectedCountry.name }
            : null,
          stateId: selectedState
            ? { value: selectedState.id, label: selectedState.name }
            : null,
          cityId: selectedCity
            ? { value: selectedCity.id, label: selectedCity.name }
            : null,
          numberOfEmployees: selectedNoOfEmployeeOption
            ? {
                value: selectedNoOfEmployeeOption.id,
                label: selectedNoOfEmployeeOption.value,
              }
            : null,
        });

        setIsOrgDataFetched(true);
      } catch (error) {
        console.error("Error fetching organization data:", error);
      }
    };

    if (countries.length > 0 && elementsData.length > 0 && !isOrgDataFetched) {
      fetchOrganizationData();
    }
  }, [countries, elementsData, reset, isOrgDataFetched, token, organizationId]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];

    if (file) {
      setLogoFileName(file.name);

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("base64String", base64String, { shouldValidate: true });
        setPreviewUrl(reader.result);
        trigger("companyLogo");
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };

  // const handleAttachmentFileChange = (event, index) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     setFileCounts((prevCounts) => ({
  //       ...prevCounts,
  //       [index]: 1,
  //     }));

  //     setValue(`elements[${index}].elementDetail.fileName`, file.name, {
  //       shouldValidate: true,
  //     });

  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       const base64String = reader.result.split(",")[1];

  //       setValue(
  //         `elements[${index}].elementDetail.base64String`,
  //         base64String,
  //         { shouldValidate: true }
  //       );
  //     };

  //     reader.readAsDataURL(file);
  //   } else {
  //     setFileCounts((prevCounts) => ({
  //       ...prevCounts,
  //       [index]: 0,
  //     }));

  //     setValue(`elements[${index}].elementDetail.fileName`, "", {
  //       shouldValidate: true,
  //     });
  //     setValue(`elements[${index}].elementDetail.base64String`, "", {
  //       shouldValidate: true,
  //     });
  //     setValue(`elements[${index}].elementDetail.filePath`, "", {
  //       shouldValidate: true,
  //     });
  //   }
  // };

  const handleAttachmentFileChange = (event, index) => {
    const file = event.target.files[0]; // Get only the first selected file

    if (file) {
      // Update the file count to 1 since we're only allowing one file
      setFileCounts((prevCounts) => ({
        ...prevCounts,
        [index]: 1,
      }));

      // Set the file name
      setValue(`elements[${index}].elementDetail.fileName`, file.name, {
        shouldValidate: true,
      });

      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];

        // Set base64 string for the file
        setValue(
          `elements[${index}].elementDetail.base64String`,
          base64String,
          { shouldValidate: true }
        );

        // Create a URL for the uploaded file to display as a preview
        const fileUrl = URL.createObjectURL(file);
        setFileUrls((prevUrls) => ({
          ...prevUrls,
          [index]: fileUrl, // Update the fileUrls state with the new URL
        }));
      };

      reader.readAsDataURL(file); // Read the file as a Data URL
    } else {
      // Reset the file count to 0 if no file is selected
      setFileCounts((prevCounts) => ({
        ...prevCounts,
        [index]: 0,
      }));

      // Clear the file fields
      setValue(`elements[${index}].elementDetail.fileName`, "", {
        shouldValidate: true,
      });
      setValue(`elements[${index}].elementDetail.base64String`, "", {
        shouldValidate: true,
      });
      setValue(`elements[${index}].elementDetail.filePath`, "", {
        shouldValidate: true,
      });

      // Clear the file URL
      setFileUrls((prevUrls) => ({
        ...prevUrls,
        [index]: "", // Reset the file URL
      }));
    }
  };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const elements = data.elements
      .map((element) => {
        if (!element.name || element.name.value === undefined) {
          return null;
        }

        return {
          id: element.name.value || 0,
          name: element.name?.label || element.name || "",
          description: element.description || "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: element.elementDetail?.value || "",
            description: element.elementDetail?.description || "",
            effectiveDate: element.elementDetail?.effectiveDate || null,
            endDate: element.elementDetail?.endDate || null,
            createdBy: localStorage.getItem("userId"),
            fileName: element.elementDetail?.fileName || "",
            filePath: element.elementDetail?.filePath || "",
            base64String: element.elementDetail?.base64String || "",
          },
        };
      })
      .filter((element) => element !== null);

    const formData = {
      ...data,
      elements: elements.length > 0 ? elements : null,
      companyLogo: logoFileName,
      countryId: data.countryId.value || data.countryId.id,
      stateId: data.stateId.value || data.stateId.id,
      cityId: data.cityId.value || data.cityId.id,
      numberOfEmployees:
        data.numberOfEmployees.value || data.numberOfEmployees.id,
    };

    try {
      const response = await post("Organization", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (response.isSuccess) {
        toast.success("Success!");

        if (!organizationId || organizationId === "null") {
          const orgUserDetails = response.organization.user;

          showModalWithContent(
            "Organization Created",
            <div className="fs-9">
              <p>
                <strong>Username</strong>: {orgUserDetails?.userName}
              </p>
              <p>
                <strong>Password</strong>: {orgUserDetails?.passwordHash}
              </p>
            </div>
          );
          reset();
        }
      } else {
        toast.error(response.message || "An unexpected error occurred");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };
  const handleCustomDropdownSetting = (dropdownName) => {
    setCustomDropdownName(dropdownName);
    setIsCustomDropdownValuesModalVisible(true);
  };
  const [numberOfEmployeesData, setnumberOfEmployeesData] = useState([]);
  const fetchNoOfEmployees = async () => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=numberOfEmployees`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setnumberOfEmployeesData(response?.commonSettingDetail);
    } catch (error) {
      console.error("Error fetching noOfEmployees:", error);
    }
  };

  useEffect(() => {
    fetchNoOfEmployees();
  }, []);

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Organization Form</h2>
        {/* <div className="ms-auto">
          <Link
            to="/organization-form"
            className="btn btn-outline-primary btn-sm"
          >
            Add New
          </Link>
        </div> */}
      </div>

      <div className="card">
        <div className="card-body">
          <form
            className="row g-3 new-form-style"
            onSubmit={handleSubmit(saveData)}
          >
            <div className="col-md-12">
              <div className="row g-3 justify-content-center">
                <div className="col-md-3">
                  <div className="image-uploader-wrapper d-flex flex-column align-items-center">
                    <div className="image-preview d-flex justify-content-center align-items-center mb-3">
                      {previewUrl ? (
                        <img src={previewUrl} alt="Preview" />
                      ) : (
                        <div>
                          <span className="fas fa-image fs-3 text-light"></span>
                        </div>
                      )}
                    </div>
                    <label className="form-label">Organization Logo</label>
                    <input
                      {...register("companyLogo")}
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  {errors.companyLogo && (
                    <small className="text-danger">
                      {errors.companyLogo.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill">
              Organization Information
            </h5>

            <div className="col-md-3">
              <label className="form-label form-label-new">
                Brand Name<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("name", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("name")}
              />
              {errors.name && (
                <small className="text-danger">{errors.name.message}</small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Legal Name<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("legalName", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("legalName")}
              />
              {errors.legalName && (
                <small className="text-danger">
                  {errors.legalName.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Registration Number<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("registrationNumber", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  "registrationNumber"
                )}
              />
              {errors.registrationNumber && (
                <small className="text-danger">
                  {errors.registrationNumber.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Number of Employees<span className="text-danger fs-9">*</span>
              </label>
              <div className="d-flex gap-2">
                <div className="w-100">
                  <Controller
                    name="numberOfEmployees"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={numberOfEmployeesData.map((employee) => ({
                          value: employee.id,
                          label: employee.value,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("numberOfEmployees", null);
                          } else {
                            setValue("numberOfEmployees", selectedOption);
                          }
                          trigger("numberOfEmployees");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        isClearable
                      />
                    )}
                  />
                  {errors.numberOfEmployees && (
                    <small className="text-danger">
                      {errors.numberOfEmployees.message}
                    </small>
                  )}
                </div>
                <div>
                  <button
                    type="button"
                    className="btn btn-outline-primary px-2 lh-1"
                    onClick={() =>
                      handleCustomDropdownSetting("numberOfEmployees")
                    }
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Founded Date<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("foundedDate", {
                  required: "This field is required.",
                  validate: (value) => {
                    const selectedDate = new Date(value);
                    const today = new Date();
                    if (selectedDate > today) {
                      return "Must be less than or equal to today.";
                    }
                    return true;
                  },
                })}
                type="date"
                className="form-control"
                placeholder=""
                max={new Date().toISOString().split("T")[0]} // Disable future dates
              />
              {errors.foundedDate && (
                <small className="text-danger">
                  {errors.foundedDate.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Business Description<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("businessDescription", {
                  required: "This field is required.",
                  maxLength: {
                    value: 250,
                    message: "Maximum of 250 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  "businessDescription"
                )}
              />
              {errors.businessDescription && (
                <small className="text-danger">
                  {errors.businessDescription.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Account Length (1-5)<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("accountLength", {
                  required: "This field is required.",
                  min: {
                    value: 1,
                    message: "The minimum value is 1.",
                  },
                  max: {
                    value: 5,
                    message: "The maximum value is 5.",
                  },
                })}
                type="number"
                className="form-control"
                placeholder=""
                onInput={(e) => {
                  e.target.setCustomValidity("");
                }}
              />
              {errors.accountLength && (
                <small className="text-danger">
                  {errors.accountLength.message}
                </small>
              )}
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill mt-4">
              Contact Information
            </h5>

            <div className="col-md-3">
              <label className="form-label form-label-new">
                Country<span className="text-danger fs-9">*</span>
              </label>

              <Controller
                name={`countryId`}
                control={control}
                rules={{ required: "This field is required." }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={countries.map((country) => ({
                      value: country.id,
                      label: country.name,
                    }))}
                    onChange={(selectedOption, actionMeta) => {
                      if (actionMeta.action === "clear") {
                        setValue(`countryId`, null);
                      } else {
                        setValue(
                          `countryId`,
                          selectedOption || { value: 0, label: "" }
                        );
                      }
                      trigger(`countryId`);
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                    // isClearable
                  />
                )}
              />
              {errors.countryId && (
                <small className="text-danger">
                  {errors.countryId.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                State<span className="text-danger fs-9">*</span>
              </label>

              <Controller
                name={`stateId`}
                control={control}
                rules={{ required: "This field is required." }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={states.map((state) => ({
                      value: state.id,
                      label: state.name,
                    }))}
                    onChange={(selectedOption, actionMeta) => {
                      if (actionMeta.action === "clear") {
                        setValue(`stateId`, null);
                      } else {
                        setValue(
                          `stateId`,
                          selectedOption || { value: 0, label: "" }
                        );
                      }
                      trigger(`stateId`);
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                    // isClearable
                  />
                )}
              />
              {errors.stateId && (
                <small className="text-danger">{errors.stateId.message}</small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                City<span className="text-danger fs-9">*</span>
              </label>

              <Controller
                name={`cityId`}
                control={control}
                rules={{ required: "This field is required." }}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={cities.map((city) => ({
                      value: city.id,
                      label: city.name,
                    }))}
                    onChange={(selectedOption, actionMeta) => {
                      if (actionMeta.action === "clear") {
                        setValue(`cityId`, null);
                      } else {
                        setValue(
                          `cityId`,
                          selectedOption || { value: 0, label: "" }
                        );
                      }
                      trigger(`cityId`);
                    }}
                    className="react-select-style"
                    classNamePrefix="react-select-style-pref"
                    // isClearable
                  />
                )}
              />
              {errors.cityId && (
                <small className="text-danger">{errors.cityId.message}</small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Postal Code<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("postalCode", {
                  required: "This field is required.",
                  maxLength: {
                    value: 10,
                    message: "Maximum of 10 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("postalCode")}
              />
              {errors.postalCode && (
                <small className="text-danger">
                  {errors.postalCode.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Address<span className="text-danger fs-9">*</span>
              </label>
              <textarea
                {...register("address", {
                  required: "This field is required.",
                  maxLength: {
                    value: 250,
                    message: "Maximum of 250 characters allowed.",
                  },
                })}
                className="form-control custom-textarea"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("address")}
              ></textarea>
              {/* <input
            {...register("address", {
              required: "This field is required.",
            })}
            type="text"
            className="form-control"
            placeholder=""
          /> */}
              {errors.address && (
                <small className="text-danger">{errors.address.message}</small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Phone Number<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("phoneNumber", {
                  required: "This field is required.",
                  pattern: {
                    value:
                      /^(\+?(\d{1,3}))?(\(?\d{3}\)?[-.\s]?)?(\d{3})[-.\s]?(\d{4})$/, // Regex for phone number validation
                    message: "Please enter a valid phone number.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
              />
              {errors.phoneNumber && (
                <small className="text-danger">
                  {errors.phoneNumber.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Email Address<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("emailAddress", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("emailAddress")}
              />
              {errors.emailAddress && (
                <small className="text-danger">
                  {errors.emailAddress.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Website Url<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("websiteUrl", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/, // Regex for URL validation
                    message: "Please enter a valid URL.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("websiteUrl")}
              />
              {errors.websiteUrl && (
                <small className="text-danger">
                  {errors.websiteUrl.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Primary Contact Name<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("primaryContactName", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  "primaryContactName"
                )}
              />
              {errors.primaryContactName && (
                <small className="text-danger">
                  {errors.primaryContactName.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Primary Contact Designation
                <span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("primaryContactTitle", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  "primaryContactTitle"
                )}
              />
              {errors.primaryContactTitle && (
                <small className="text-danger">
                  {errors.primaryContactTitle.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Primary Contact Email<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("primaryContactEmail", {
                  required: "This field is required.",
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Please enter a valid email.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  "primaryContactEmail"
                )}
              />
              {errors.primaryContactEmail && (
                <small className="text-danger">
                  {errors.primaryContactEmail.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Primary Contact Phone<span className="text-danger fs-9">*</span>
              </label>
              <input
                {...register("primaryContactPhone", {
                  required: "This field is required.",
                  pattern: {
                    value:
                      /^(\+?(\d{1,3}))?(\(?\d{3}\)?[-.\s]?)?(\d{3})[-.\s]?(\d{4})$/, // Regex for phone number validation
                    message: "Please enter a valid phone number.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
              />
              {errors.primaryContactPhone && (
                <small className="text-danger">
                  {errors.primaryContactPhone.message}
                </small>
              )}
            </div>

            <h5 className="mb-0 p-2 px-3 mt-4 text-secondary bg-brand-light rounded-pill mt-4">
              Social Media Information
            </h5>

            <div className="col-md-3">
              <label className="form-label form-label-new">
                LinkedIn Profile
              </label>
              <input
                {...register("linkedInProfile", {
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/,
                    message: "Please enter a valid URL.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("linkedInProfile")}
              />
              {errors.linkedInProfile && (
                <small className="text-danger">
                  {errors.linkedInProfile.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Facebook Profile
              </label>
              <input
                {...register("facebookProfile", {
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/,
                    message: "Please enter a valid URL.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("facebookProfile")}
              />
              {errors.facebookProfile && (
                <small className="text-danger">
                  {errors.facebookProfile.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Twitter Handle
              </label>
              <input
                {...register("twitterHandle", {
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/,
                    message: "Please enter a valid URL.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck("twitterHandle")}
              />
              {errors.twitterHandle && (
                <small className="text-danger">
                  {errors.twitterHandle.message}
                </small>
              )}
            </div>
            <div className="col-md-3">
              <label className="form-label form-label-new">
                Instagram Profile
              </label>
              <input
                {...register("instagramProfile", {
                  maxLength: {
                    value: 75,
                    message: "Maximum of 75 characters allowed.",
                  },
                  pattern: {
                    value:
                      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,6}(\/[a-zA-Z0-9#]+\/?)*$/,
                    message: "Please enter a valid URL.",
                  },
                })}
                type="text"
                className="form-control"
                placeholder=""
                onChange={handleChangeOfInputWithLengthCheck(
                  "instagramProfile"
                )}
              />
              {errors.instagramProfile && (
                <small className="text-danger">
                  {errors.instagramProfile.message}
                </small>
              )}
            </div>

            <Elements
              fields={fields}
              control={control}
              register={register}
              errors={errors}
              watch={watch}
              elementsData={elementsData}
              append={append}
              remove={remove}
              handleAttachmentFileChange={handleAttachmentFileChange}
              fileCounts={fileCounts}
              fileUrls={fileUrls}
              setValue={setValue}
              getValues={getValues}
              trigger={trigger}
            />

            <div className="col-12">
              <button
                className="btn btn-primary btn-sm"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Save" : "Save"}
              </button>
            </div>
          </form>
        </div>
      </div>

      {isModalVisible && (
        <CustomModal
          title={modalTitle}
          content={modalContent}
          onClose={hideModal}
        />
      )}
      {isCustomDropdownValuesModalVisible && (
        <DropdownWithCustomValuesModal
          dropdownName={customDropdownName}
          onClose={() => {
            setIsCustomDropdownValuesModalVisible(false);
            if (customDropdownName === "numberOfEmployees") {
              fetchCommonSettings(
                "numberOfEmployees",
                setnumberOfEmployeesData
              );
            }
          }}
        />
      )}
    </>
  );
}

export default OrganizationForm;
